<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">

			<el-form-item label="图标:">
				<el-upload class="avatar-uploader" :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="ruleForm.pay_icon" :src="ruleForm.pay_icon" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
			
			
			<el-form-item label="通道类型" prop="types">
				<el-radio v-model="ruleForm.types" :label="1">线上支付</el-radio>
				  <el-radio v-model="ruleForm.types" :label="2">线下支付</el-radio>
			</el-form-item>
			
			<el-form-item label="通道类型" prop="onlineType">
				<el-radio v-model="ruleForm.onlineType" :label="1">支付宝</el-radio>
				<el-radio v-model="ruleForm.onlineType" :label="2">微信支付</el-radio>
				<el-radio v-model="ruleForm.onlineType" :label="3">银行卡</el-radio>
			</el-form-item>
			
			<el-form-item label="通道名称" prop="pay_name">
				<el-input size="small" v-model="ruleForm.pay_name"></el-input>
			</el-form-item>
			
			<el-form-item label="通道编码" prop="pay_code">
				<el-input size="small" v-model="ruleForm.pay_code"></el-input>
			</el-form-item>
			
			<div style="display: flex; flex-direction: row; align-items: center;">
				<el-form-item label="店铺开关" prop="shop_status">
					<el-switch v-model="ruleForm.shop_status" active-color="#3399ff" inactive-color="#EFEFEF" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="平台开关" prop="plat_status">
					<el-switch v-model="ruleForm.plat_status" active-color="#3399ff" inactive-color="#EFEFEF" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</div>
			
			<el-form-item label="服务费" prop="pay_code">
				<el-input type="number" size="small" v-model="ruleForm.fee"></el-input>
			</el-form-item>
				
			<el-form-item label="充值说明:" prop="pay_desc">
				<el-input size="small" v-model="ruleForm.pay_desc"></el-input>
			</el-form-item>
			
			<el-form-item label="最低限额:" prop="low_limit">
				<el-input type="number" size="small" v-model="ruleForm.low_limit"></el-input>
			</el-form-item>
			<el-form-item label="最高限额:" prop="high_limit">
				<el-input type="number" size="small" v-model="ruleForm.high_limit"></el-input>
			</el-form-item>
			<el-form-item label="快捷金额:" prop="amount_list">
				<el-input size="small" v-model="ruleForm.amount_list"></el-input>
			</el-form-item>
			<el-form-item label="描述配置:">
				<el-input size="small" v-model="ruleForm.desc_param"></el-input>
			</el-form-item>
			<el-form-item label="配置:">
				<el-input size="small" v-model="ruleForm.params"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button style="width: 300px;" type="danger" @click="submitForm('ruleForm')">立即修改</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['ruleForm'],
	    data() {
			return {
				rules: {
					pay_icon: [{required: true, message: '请输入上传图标', trigger: 'blur'}],
					pay_name: [{required: true, message: '请输入渠道名称', trigger: 'blur'}],
					pay_code: [{required: true, message: '请输入渠道编码', trigger: 'blur'}],
					unit: [{required: true, message: '请输入单位', trigger: 'blur'}],
					pay_desc: [{required: true, message: '请输入渠道说明', trigger: 'blur'}],
					low_limit: [{required: true, message: '请输入最低限额', trigger: 'blur'}],
					high_limit: [{required: true, message: '请输入最高限额', trigger: 'blur'}],
					amount_list: [{required: true, message: '请输入快捷金额列表', trigger: 'blur'}],
					
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				console.log(res);
				if(res.code == 200)
				{
					this.ruleForm.pay_icon = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '修改中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Recharge/editPayin", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '修改成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 80px;
	    height: 80px;
	    line-height: 80px;
	    text-align: center;
		border: solid 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 80px;
	    height: 80px;
	    display: block;
	  }
</style>